import i18next from 'i18next'
import locI18next from 'loc-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

export default function i18n() {
  const localize = locI18next.init(i18next)

  i18next.use(LanguageDetector).init(
    {
      debug: true,
      fallbackLng: 'cn',
      resources: {
        cn: {
          translation: {
            page: {
              title: '隐私协议'
            }
          }
        },
        en: {
          translation: {
            page: {
              title: 'Privacy agreement'
            }
          }
        }
      }
    },
    (err, t) => {
      if (!err) {
        localize('html')
      }
    }
  )
}
